import { createReducer } from '@reduxjs/toolkit';
import adjustmentsForDocumentUpdated from '../actions/adjustmentsForDocumentUpdated';
import { extractAdjustmentLines } from '../utilities/extractAdjustmentLines';
import {
  summateAdjustments,
  summateRevenueAdjustments,
} from '../utilities/adjustmentSummationUtilities';
import resetCalculationDataForDocument from '../actions/resetCalculationDataForDocument';
import { clearAllProjectData } from '../actions/clearAllProjectData';

const IGNORE_ACTIVE_FLAG = true;

const isInvalidPayload = (payload) =>
  payload === undefined ||
  payload.documentCode === undefined ||
  payload.adjustments === undefined;

const adjustmentSumsByDocument = createReducer(
  {},
  {
    [adjustmentsForDocumentUpdated]: (state, action) => {
      if (isInvalidPayload(action.payload)) {
        return state;
      }

      const { documentCode, adjustments: adjustmentsForDocument } =
        action.payload;
      const adjustmentLines = extractAdjustmentLines(adjustmentsForDocument);
      const summedAdjustments = summateAdjustments(
        adjustmentLines,
        IGNORE_ACTIVE_FLAG
      );
      const revenueAdjustments = summateRevenueAdjustments(
        adjustmentLines,
        IGNORE_ACTIVE_FLAG
      );

      return {
        ...state,
        [documentCode]: {
          ...summedAdjustments,
          ...revenueAdjustments,
        },
      };
    },
    [resetCalculationDataForDocument]: (state, action) => {
      if (!action.payload || !action.payload.documentCode) {
        return state;
      }
      const { documentCode } = action.payload;
      delete state[documentCode];
      return state;
    },
    [clearAllProjectData]: () => ({}),
  }
);

export default adjustmentSumsByDocument;
